import PageModel from '@/models/pageModel';

export class Specializations extends PageModel {
    static moduleName = 'specializations';
    static moduleEntityName = 'specialization';
    static listTitle = 'Справочник специализаций';
    static createTitle = 'Добавление новой специализации';
    static apiPrefix = 'specializations';
}
